<div class="notification-wrapper" [ngClass]="{show: show}">
    <div class="notifications-header">
        <h5>{{'NOTIFICATIONS.recentNotifications' | translate}}</h5>
        <onwac-button 
            [text]="'FUNNEL.refresh' | translate" 
            [type]="'icon'" 
            [icon]="'autorenew'" 
            (click)="loadFirstNotifications()"></onwac-button>
    </div>
    <div class="notification-feed">

        <div class="onwac-tab">
            <div class="tab-item" (click)="tabs.active(item)" [ngClass]="{active: item.active}" *ngFor="let item of tabs.tabItems">
                {{item.value}}
            </div>
        </div>


        <div *ngIf="tabs.currentTabItem" class="h-100">
            <div *ngIf="tabs.currentTabItem.id === 0 && notifications[0].length > 0" class="notification-feed_top-bar d-flex justify-content-between align-items-center">
                <span class="text-uppercase">{{'NOTIFICATIONS.latestNotifications' | translate}}</span>
                <onwac-button 
                  [text]="'NOTIFICATIONS.markAllAsReaded' | translate" 
                  [type]="'text'" 
                  (click)="markAllAsReaded()"></onwac-button>
            </div>
    
            <div class="scrollable" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"  (scrolled)="loadMoreNotifications(tabs.currentTabItem.id)">
                <div class="notification" *ngFor="let noti of notifications[tabs.currentTabItem.id]">
                    <div class="notification__header d-flex justify-content-between">
                        <div class="notification__text">
                            <p>{{noti.content}}</p>
                            <div class="date d-flex justify-content-between">
                                <a *ngIf="noti.associated_type === 'deal'; else elseBlock" [routerLink]="['/funnel/deal/'+noti.associated_id]">Ver más información</a>
                                <ng-template #elseBlock><div></div></ng-template>
                                <span>{{noti.created_at | date:'EEEE d MMMM y'}}</span>
                            </div>
                        </div>
                        <div 
                        class="circle-toggler" 
                        [ngClass]="{active: noti.status === 'received'}" 
                        (click)="toggleNotificationStatus(noti)"></div>
                    </div>
                </div>
                <div *ngIf="tabs.currentTabItem.id === 0 && notifications[0] && notifications[0].length === 0" class="w-100 h-100 d-flex justify-content-center align-items-center">
                    <p>
                        {{ 'NOTIFICATIONS.noNotifications' | translate}} :)
                    </p>
                </div>

            </div>
        </div>


        
    </div>
</div>


<div class="overlay" [ngClass]="{show: show}" (click)="toggleNotifications()"></div>